import styled from 'styled-components';

export const TreatmentsLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TreatmentsToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 18px;
`;

export const TreatmentsSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(240px, 0.7fr);
  gap: 16px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

export const TreatmentsStatsCard = styled.div`
  padding: 18px;
  border-radius: 20px;
  border: 1px solid rgba(24, 90, 66, 0.08);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.96) 0%,
    rgba(248, 252, 250, 0.96) 100%
  );
  box-shadow: 0 16px 40px rgba(18, 62, 51, 0.06);
`;

export const TreatmentsStatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const TreatmentsStatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .label {
    font-size: 0.78rem;
    color: #789286;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 700;
  }

  .value {
    font-size: 1.4rem;
    font-weight: 700;
    color: #143d30;
  }

  .value.success {
    color: #15803d;
  }

  .value.warning {
    color: #b7791f;
  }

  .value.info {
    color: #2f5d89;
  }
`;

export const TreatmentsFilterCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  border-radius: 20px;
  border: 1px solid rgba(24, 90, 66, 0.08);
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 16px 40px rgba(18, 62, 51, 0.06);
`;

interface IApproval {
  success: boolean;
}

export const ApprovalContainer = styled.div<IApproval>`
  display: flex;
  background: ${(props) => (props.success ? '#32cf5c' : '#ed4140')};
  font-weight: 600;
  color: #fff;
  padding: 2px;
  border-radius: 6px;
  justify-content: center;
`;

export const PendentContainer = styled.div`
  display: flex;
  background: '#9F9C9C';
  font-weight: 600;
  padding: 2px;
  border-radius: 6px;
  justify-content: center;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
